import { Tabs } from 'antd';
import React, { FC } from 'react';
import DefaultGroupsListPage from './default-group-list';
import { useTranslation } from 'react-i18next';
import LicenseManagerGroupListPage from './license-manager-group-list';

const GroupListsMainPage: FC = () => {
  const { t } = useTranslation();

  return (
    <Tabs type="card">
      <Tabs.TabPane destroyInactiveTabPane key={'default-groups'} tabKey={'default-groups'} tab={t('DefaultGroups')}>
        <DefaultGroupsListPage />
      </Tabs.TabPane>
      <Tabs.TabPane destroyInactiveTabPane key={'license-manager-groups'} tabKey={'license-manager-groups'} tab={t('LicenseManagerGroups')}>
        <LicenseManagerGroupListPage />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default GroupListsMainPage;
